<alaris-dialog [closeAction]="close.bind(this)" [confirmAction]="confirm.bind(this)" [loading$]="dataService.loading$"
	size="md">
	<h6 slot="header">{{ 'import_rates.title' | translate }}</h6>
	<div slot="content">
		<alaris-select2 [alarisLoading]="sourcesService.loading$" [backdrop]="false" [expandable]="true"
			[label]="'import_rates.source' | translate" [formControl]="source" mode="string">
			<alaris-select-filter2 [formControl]="sourcesFilter"></alaris-select-filter2>
			@for (source of sources; track source) {
				<alaris-options2 [value]="source.Name">
					<span>
						{{ source.Name }}
					</span>
				</alaris-options2>
			}
		</alaris-select2>
		<alaris-file-loader (fileListChanges)="addFiles($event)" [exportInternally]="true"
			[fileTypes]="'.xls,.xlsx,.csv'" [maxSize]="10485760" [files]="file? [file] : []" [multiple]="false"
			data-testid="contactsFile">
		</alaris-file-loader>
	</div>
</alaris-dialog>